import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import PictureFastStyleCard from '@src/framework/workbench/common/components/selectable-panel/picture-fast-style-card';
import { PictureFastStyleConfigs } from './fast-style-config';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { transaction } from '@src/slide/domain/slide-app';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { isImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';
import Styles from './index.less';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';

// Panel中展示的个数
const PANEL_COL_NUM = 5;

@Feature()
export class PictureFastStyleFeature extends BaseSelectablePanelFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public getContent() {
        return <div className={Styles['picture-fast-style']}>
            <SelectablePanel
                colNumber={PANEL_COL_NUM}
                showArrow={true}
                expandHeight={'auto'}
                childrenElements={
                    [
                        {
                            cardList: PictureFastStyleConfigs.map(item => ({
                                element: <PictureFastStyleCard
                                    icon={item.icon}
                                    text={item.title}
                                    id={item.id}
                                    key={item.id}
                                    onClick={this.handleCardClick}
                                />,
                                id: String(item.id),
                            })),
                        },
                    ]
                } />
        </div>;
    }

    public shouldDisabled() {
        const model = this.getSelectModel() as IElementBaseModel;
        return !!isImageFillShape(model) || isPreviewOnly();
    }

    private handleCardClick = (id: number) => {
        const config = PictureFastStyleConfigs.find(item => item.id === id);
        if (config) {
            const { style } = config;
            const model = this.getSelectionService().getSelectedModel() as IElementBaseModel;
            const selectedModels = getAllChildModels(model);
            transaction(() => {
                selectedModels.forEach((model) => {
                    if (model.type === UIModelType.IMAGE) {
                        (model as IPictureModel).handleResetPicture(false, false);
                        (model as IPictureModel).updateStyle(style);
                    }
                });
            });
        }
    };
}
